var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compte",
    transform: "translate(-228.000000, -59.000000)",
    stroke: "#000000",
    strokeWidth: 1.34
  }, /*#__PURE__*/React.createElement("g", {
    id: "account_black",
    transform: "translate(229.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.88333333,0.878 C5.16733333,-0.292666667 6.83266667,-0.292666667 7.11666667,0.878 C7.20309536,1.23470614 7.45468916,1.52868283 7.79376771,1.66916387 C8.13284625,1.80964492 8.51862739,1.77973417 8.832,1.58866667 C9.86066667,0.962 11.0386667,2.13933333 10.412,3.16866667 C10.2212083,3.4819026 10.1913697,3.86738738 10.3316853,4.20625278 C10.4720009,4.54511818 10.7656192,4.79666766 11.122,4.88333333 C12.2926667,5.16733333 12.2926667,6.83266667 11.122,7.11666667 C10.7652939,7.20309536 10.4713172,7.45468916 10.3308361,7.79376771 C10.1903551,8.13284625 10.2202658,8.51862739 10.4113333,8.832 C11.038,9.86066667 9.86066667,11.0386667 8.83133333,10.412 C8.5180974,10.2212083 8.13261262,10.1913697 7.79374722,10.3316853 C7.45488182,10.4720009 7.20333234,10.7656192 7.11666667,11.122 C6.83266667,12.2926667 5.16733333,12.2926667 4.88333333,11.122 C4.79690464,10.7652939 4.54531084,10.4713172 4.20623229,10.3308361 C3.86715375,10.1903551 3.48137261,10.2202658 3.168,10.4113333 C2.13933333,11.038 0.961333333,9.86066667 1.588,8.83133333 C1.77879169,8.5180974 1.80863026,8.13261262 1.66831469,7.79374722 C1.52799912,7.45488182 1.23438081,7.20333234 0.878,7.11666667 C-0.292666667,6.83266667 -0.292666667,5.16733333 0.878,4.88333333 C1.23470614,4.79690464 1.52868283,4.54531084 1.66916387,4.20623229 C1.80964492,3.86715375 1.77973417,3.48137261 1.58866667,3.168 C0.962,2.13933333 2.13933333,0.961333333 3.16866667,1.588 C3.83533333,1.99333333 4.69933333,1.63466667 4.88333333,0.878 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBlack);
export default __webpack_public_path__ + "static/media/account_black.e48bf279436e1f5c71f2f2e6441cf916.svg";
export { ForwardRef as ReactComponent };